<template>
  <div class="modal is-active">
    <div @click="$emit('close')" class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Video</p>
        <button @click="$emit('close')" class="delete"></button>
      </header>
      <section class="modal-card-body">
        <form>

          <p class="field flex-space-between flex-align-center">
            <input
              @click="showUploader()"
              class="button is-primary"
              value="Upload Video"
              type='button'
              :disabled="fileUploaded"
              />
              <span v-if="fileUploaded">
                <span class="is-success">Uploaded:</span>
                <span>{{ this.title }}</span>
              </span>
          </p>

          <input
            class="title is-2 input"
            v-model="title"
            placeholder="video title"
            />

          <p>
            <textarea
              class="subtitle textarea"
              placeholder="Add video description"
              v-model="description"
              />
          </p>

          <section v-show="!hideCycles">
            <h2 class="title is-2">Cycles</h2>

            <ul v-if="cycles.length > 0">

              <li class="panel-block flex-space-between" v-for="cycle in cycles">

                <div class="flex-align-center">
                  <router-link to="/cycles">{{ cycle.title }}</router-link>
                  <p class="current-cycle" v-if="cycle.id === cycleID">(current cycle)</p>
                </div>

                <input
                  name="cycle"
                  type="radio"
                  :id='cycle.id'
                  :checked="cycle.id === cycleID || videoInCycle(cycle, videoID)"
                  ref="cycleRadio"
                  />

              </li>

            </ul>

            <p v-else>
              No cycles found.
            </p>
          </section>

          <p class="uploadfor flex-align-center" v-if="isCoach && userID">
            <label>Video Owner: </label>
            <span class="select">
              <select v-model="owner">
                <option v-for="t in teachers" :value=t.id>{{ t.name || t.email }}</option>
              </select>
            </span>
          </p>

        </form>
      </section>
      <footer class="modal-card-foot">
        <a
          @click='createVideo()'
          class="button is-primary"
          :disabled="!fileUploaded"
          :class="loading && 'is-loading'"
          >Send to Processing</a>
        <a
          @click="$emit('close')"
          class="button"
          >Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>
import filestack from 'filestack-js'

import store from '../store.js'

import Raven from 'raven-js'

export default {
  name: 'AddVideoModal',
  data () {
    return {
      description: '',
      title: '',
      // aws key from file upload
      key: '',
      fileUploaded: false,
      size: 0,
      source: '',
      mimetype: '',
      container: '',
      owner: this.userID,
    }
  },
  mounted () {
    store.dispatch('fetchGroup')
  },
  computed: {
    cycles () {
      return store.state.cycles
    },
    user () {
      return store.state.user
    },
    isCoach () {
      return store.state.user.is_coach || store.state.user.is_group_admin
    },
    loading () {
      return store.state.sendingToProcessing
    },
    teachers () {
      return store.state.group.users
    },
  },
  props: {
    videoID: {
      required: true,
    },
    cycleID: {
      required: true,
    },
    hideCycles: {
      required: true,
    },
    userID: {
      type: Number,
      required: false,
    },
  },
  methods: {
    createVideo () {
      const radioButtons = this.$refs.cycleRadio

      var cycle = null
      if (radioButtons !== undefined) {
        cycle = radioButtons.find(x => x.checked).id
      }

      let user = this.user.id
      if (user !== this.owner) {
        user = this.owner
      }
      const data = {
        key: this.key,
        title: this.title,
        description: this.description,
        file_size: this.size,
        upload_client: this.source,
        vtype: this.mimetype,
        // bucket is called container by filestack
        bucket: this.container,
        user: user,
        cycle: cycle,
      }

      store.dispatch('createVideo', data)
    },
    showUploader () {
      const filename = new Date().getTime()
      const originalPath = `/video/original/${this.user.id}/${filename}/`

      const client = filestack.init('AGh5gQoiS1W1Ifxa0Ht6uz')
      client.pick({
        accept: 'video/*',
        startUploadingWhenMaxFilesReached: true,
        hideWhenUploading: false,
        disableTransformer: true,
        fromSources: ['local_file_system', 'dropbox', 'googledrive', 'onedrive'],
        storeTo: {
          location: 's3',
          path: originalPath,
          container: 'classforward',
          region: 'us-east-1',
          access: 'private',
        },
      })
      .then(data => {
        if (data.filesFailed.length > 0) {
          console.warn('error with file upload', data.filesFailed)
        }
        if (data.filesUploaded.length > 0) {
          const file = data.filesUploaded[0]
          if (this.title === '') {
            this.title = file.filename
          }
          this.fileUploaded = true
          this.key = file.key
          this.size = file.size
          this.source = file.source
          this.mimetype = file.mimetype
          this.container = file.container
        }
      })
      .catch(error => {
        console.warn('error with uploader', error)
        Raven.captureException(error)
      })
    },
    videoInCycle (cycle, videoID) {
      return cycle && cycle.videos && cycle.videos.filter(v => v.id === videoID).length > 0
    },
    handleESC (e) {
      const ESC = 27
      if (e.keyCode === ESC) {
        this.$emit('close')
      }
    },
  },
  created () {
    document.addEventListener('keydown', this.handleESC)
  },
  beforeDestory () {
    document.removeEventListener('keydown', this.handleESC)
  },
}

</script>

<style lang="scss" scoped>

@import '../_variables.scss';

input.file-upload {
  margin-bottom: 1.5rem;
}

span.is-success {
  color: $SUCCESS;
}


.current-cycle {
  margin-left: 10px;
  margin-right: 10px;
}

.uploadfor {
  margin-top: 10px;
  label {
    margin-right: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// AddVideoModal.vue?da6b1d0c